import { useEffect, useRef, useState } from "react";
import { TbNumbers } from "react-icons/tb";
import { IoSend } from "react-icons/io5";
import "./Validate2FA.css";
import UserService from "../../services/UserService";
import Loader from "../../components/Loader/Loader";
import { useAuth } from "../../contexts/auth";
import OtpInput from "../../components/Otp/OtpInput";
import Button from "../../components/Button/Button";

function Validate2FA({ onSuccess, onCancel }) {
	const [token, setToken] = useState("");
	const [showLoader, setShowLoader] = useState(false);
	const { storeUser, storeToken, signOut } = useAuth();
	const checkButtonRef = useRef();

	async function handleSubmit(event) {
		event.preventDefault();
		setShowLoader(true);
		const response = await UserService.validate2FA(token);
		setShowLoader(false);
		if (response) {
			storeUser(response.data)
			storeToken(response.data.token)
			onSuccess?.();
		}
	}

	function handleClickCancel(e) {
		signOut();
		onCancel();
	}

	return (
		<div className="signup-container paper-background">
			<h2 style={{ textAlign: "center", marginBottom: "2rem" }}>
				Digite o código de verificação
			</h2>

			<form onSubmit={handleSubmit} className="signup-validate-2fa-container">
				<OtpInput onComplete={(value) => {
					setToken(value)
					checkButtonRef.current.focus();
				}} />
				{showLoader ? (
					<div className="loader">
						<Loader
							styles={{
								marginTop: "0",
							}}
							width={25}
							height={25}
						/>
					</div>
				) : (
					<div className="form-buttons">
						<Button
							ref={checkButtonRef}
							className={"button-blue"}
							label={"Verificar"}
							type={"submit"}
						/>
						<Button
							className={"button-white"}
							label={"Cancelar"}
							onClick={handleClickCancel}
						/>
					</div>
				)}
			</form>
		</div>
	);
}

export default Validate2FA;
